module.exports = __webpack_public_path__ + "media/images/1200/sleep_apnea_get_good_sleep-9b4a6baed561f3a62273a48d0f74a985.webp";